












import Vue from 'vue';

export default Vue.extend({
	name: 'Participate',
	data: function(){
		return {}
	}
});
